(() => {
  if (window.KiyoriCommerceLoaded) return;
  window.KiyoriCommerceLoaded = true;

  const T = Object.assign({
    soldOut: 'Sold out',
    startRoutine: 'Start routine',
    startMonthly: 'Start my monthly routine',
    addSticks: 'Add {n} sticks',
    subAdd: 'Subscribe & add',
    subAddBag: 'Subscribe & add to bag',
    addBag: 'Add to bag',
    routine30: '30-day routine',
    oneTime30: '30 sticks · one-time',
    delivered: '30 sticks delivered every four weeks · ',
    oneDelivery: 'One delivery · ',
    preferOnce: 'Prefer one-time? {p}',
    chooseMonthly: 'Choose monthly delivery · {p}',
    mornings: '{n} mornings',
    net: '{n} sticks · {g} g total',
    subscription: 'Subscription',
    perServing: ' per serving'
  }, window.KiyoriI18n || {});
  const fill = (s, o) => String(s).replace(/\{(\w+)\}/g, (m, k) => (o[k] !== undefined ? o[k] : m));

  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
    style: 'currency', currency: currency || 'CAD', maximumFractionDigits: cents % 100 ? 2 : 0
  }).format(cents / 100);

  const trackFallback = (name, detail = {}) => {
    const payload = { ...detail, page_location: location.href, timestamp: new Date().toISOString() };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
    document.dispatchEvent(new CustomEvent(name, { detail: payload }));
    if (window.Shopify?.analytics?.publish) {
      try { window.Shopify.analytics.publish(name, payload); } catch (_) {}
    }
  };
  const track = (name, detail = {}) => window.KiyoriAnalytics?.publish
    ? window.KiyoriAnalytics.publish(name, detail)
    : trackFallback(name, detail);

  const product = document.querySelector('[data-kc-product]');
  if (product) {
    const productData = () => ({
      product_id: product.dataset.productId,
      product_handle: product.dataset.productHandle,
      product_title: product.dataset.productTitle,
      variant_id: product.dataset.variantId,
      price: Number(product.dataset.price || 0) / 100,
      currency: product.dataset.currency
    });
    track('product_viewed', productData());

    const rail = product.querySelector('[data-kc-gallery-rail]');
    const slides = [...product.querySelectorAll('[data-kc-gallery-slide]')];
    const dots = [...product.querySelectorAll('[data-kc-gallery-dot]')];
    const count = product.querySelector('[data-kc-gallery-count]');
    let active = 0;
    let galleryTracked = false;
    const setActive = (index, interaction = false) => {
      active = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
      if (interaction && !galleryTracked) {
        galleryTracked = true;
        track('gallery_interacted', { ...productData(), image_position: active + 1 });
      }
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      setActive(index, true);
    }));
    let scrollTimer;
    rail?.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const index = Math.round(rail.scrollLeft / Math.max(rail.clientWidth, 1));
        if (index !== active) setActive(index, true);
      }, 80);
    }, { passive: true });

    const form = product.querySelector('.kc-form');
    const variantId = form?.querySelector('[data-kc-variant-id]');
    const sellingPlan = form?.querySelector('[data-kc-selling-plan]');
    const price = product.querySelector('[data-kc-price]');
    const oncePrice = product.querySelector('[data-kc-once-price]');
    const onceServing = product.querySelector('[data-kc-once-serving]');
    const perServing = product.querySelector('[data-kc-per-serving]');
    const planName = product.querySelector('[data-kc-plan-name]');
    const planPrice = product.querySelector('[data-kc-plan-price]');
    const planServing = product.querySelector('[data-kc-plan-serving]');
    const addPrice = product.querySelector('[data-kc-add-price]');
    const stickyPrice = product.querySelector('[data-kc-sticky-price]');
    const add = product.querySelector('[data-kc-add]');
    const stickyAdd = product.querySelector('[data-kc-sticky-add]');
    const subscriptionCard = product.querySelector('.kc-purchase__card--subscription');
    const format = product.querySelector('[data-kc-format]');
    const perServingBadge = product.querySelector('[data-kc-per-serving-badge]');
    const subscriptionNote = product.querySelector('[data-kc-subscription-note]');
    const sachetPlan = product.querySelector('[data-kc-sachet-plan]');
    const planEyebrow = product.querySelector('[data-kc-plan-eyebrow]');
    const planSummary = product.querySelector('[data-kc-plan-summary]');
    const quietOnce = product.querySelector('[data-kc-quiet-once]');

    const selectedPurchase = () => form?.querySelector('[data-kc-purchase]:checked')?.value || 'once';
    const canPurchase = (variant) => variant
      ? variant.dataset.canPurchase === 'true'
      : product.dataset.canPurchase === 'true';

    const renderSachetMode = (variant) => {
      if (!variant) return;
      const isThirty = variant.dataset.packSize === '30' || (!variant.dataset.packSize && variant.dataset.productHandle === 'creatine-matcha-sachets-30-sachets');
      const subscribed = selectedPurchase() === 'subscription' && Boolean(variant.dataset.planId);
      if (sachetPlan) sachetPlan.hidden = !isThirty;
      if (subscriptionNote) subscriptionNote.hidden = !isThirty || !subscribed;
      if (planEyebrow) planEyebrow.textContent = subscribed ? T.routine30 : T.oneTime30;
      if (planSummary) planSummary.textContent = subscribed ? T.delivered : T.oneDelivery;
      if (quietOnce) {
        quietOnce.hidden = !isThirty || !variant.dataset.planId;
        quietOnce.textContent = subscribed
          ? fill(T.preferOnce, { p: variant.dataset.priceFormatted })
          : fill(T.chooseMonthly, { p: variant.dataset.planPrice });
      }
    };

    const updateButtonLabels = (subscribed, variant, available = true) => {
      const packSize = variant?.dataset.packSize;
      [add, stickyAdd].forEach(button => {
        if (!button) return;
        button.disabled = !available;
        const label = button.querySelector('span') || button;
        if (!available) label.textContent = T.soldOut;
        else if (subscribed && packSize === '30') label.textContent = button === stickyAdd ? T.startRoutine : T.startMonthly;
        else if (!subscribed && packSize) label.textContent = fill(T.addSticks, { n: packSize });
        else label.textContent = subscribed ? (button === stickyAdd ? T.subAdd : T.subAddBag) : T.addBag;
      });
    };

    const setPurchaseMode = (mode, shouldTrack = false) => {
      const chosenVariant = form?.querySelector('[data-kc-variant]:checked');
      const subscription = form?.querySelector('[data-kc-purchase][value="subscription"]');
      const once = form?.querySelector('[data-kc-purchase][value="once"]');
      const activePlanId = chosenVariant?.dataset.planId || product.dataset.planId || '';
      const subscribed = mode === 'subscription' && Boolean(activePlanId);
      if (subscription) subscription.checked = subscribed;
      if (once) once.checked = !subscribed;
      if (sellingPlan) {
        sellingPlan.value = subscribed ? activePlanId : '';
        sellingPlan.disabled = !subscribed;
      }
      const shown = subscribed
        ? (chosenVariant?.dataset.planPrice || product.dataset.planPrice)
        : (chosenVariant?.dataset.priceFormatted || oncePrice?.textContent || price?.textContent);
      const shownPerServing = subscribed
        ? (chosenVariant?.dataset.planPerServing || product.dataset.planPerServing)
        : chosenVariant?.dataset.perServing;
      if (price && shown) price.textContent = shown;
      if (sachetPlan && planPrice && shown) planPrice.textContent = shown;
      if (perServing && shownPerServing) perServing.textContent = shownPerServing;
      if (addPrice && shown) addPrice.textContent = shown;
      if (stickyPrice && shown) stickyPrice.textContent = shown;
      updateButtonLabels(subscribed, chosenVariant, canPurchase(chosenVariant));
      renderSachetMode(chosenVariant);
      if (shouldTrack) track(subscribed ? 'subscription_selected' : 'one_time_selected', {
        ...productData(),
        supply_size: Number(chosenVariant?.dataset.packSize || 0) || null,
        selling_plan_id: subscribed ? sellingPlan.value : null,
        selling_plan_name: subscribed ? (chosenVariant?.dataset.planName || product.dataset.planName) : null
      });
    };

    const updateVariant = (input, shouldTrack = false) => {
      if (!input) return;
      const available = input.dataset.canPurchase === 'true';
      const rawPrice = Number(input.dataset.price || 0);
      product.dataset.variantId = input.value;
      product.dataset.price = rawPrice;
      product.dataset.productId = input.dataset.productId || product.dataset.productId;
      product.dataset.productHandle = input.dataset.productHandle || product.dataset.productHandle;
      product.dataset.productTitle = input.dataset.productTitle || product.dataset.productTitle;
      product.dataset.planId = input.dataset.planId || '';
      product.dataset.planName = input.dataset.planName || '';
      product.dataset.planPrice = input.dataset.planPrice || input.dataset.priceFormatted;
      product.dataset.planPerServing = input.dataset.planPerServing || input.dataset.perServing;
      variantId.value = input.value;
      if (oncePrice) oncePrice.textContent = input.dataset.priceFormatted;
      if (onceServing && input.dataset.perServing) onceServing.textContent = input.dataset.perServing.replace(T.perServing, '');
      if (format && input.dataset.format) format.textContent = input.dataset.format;
      const servings = Number(input.dataset.packSize);
      if (servings) {
        const mornings = product.querySelector('[data-kc-mornings]');
        const net = product.querySelector('[data-kc-net-quantity]');
        if (mornings) mornings.textContent = fill(T.mornings, { n: servings });
        if (net) net.textContent = fill(T.net, { n: servings, g: servings * 8 });
      }
      if (planName) planName.textContent = input.dataset.planName || T.subscription;
      if (planPrice) planPrice.textContent = input.dataset.planPrice || input.dataset.priceFormatted;
      if (planServing && (input.dataset.planPerServing || input.dataset.perServing)) planServing.textContent = (input.dataset.planPerServing || input.dataset.perServing).replace(T.perServing, '');
      if (perServingBadge && input.dataset.planPerServing) perServingBadge.textContent = input.dataset.planPerServing;
      if (subscriptionCard) subscriptionCard.hidden = !input.dataset.planId;
      const requestedMode = input.dataset.purchaseDefault || selectedPurchase();
      const subscriptionSelected = requestedMode === 'subscription' && input.dataset.planId;
      const shown = subscriptionSelected ? (input.dataset.planPrice || input.dataset.priceFormatted) : input.dataset.priceFormatted;
      const shownPerServing = subscriptionSelected ? (input.dataset.planPerServing || input.dataset.perServing) : input.dataset.perServing;
      if (price && shown) price.textContent = shown;
      if (perServing && shownPerServing) perServing.textContent = shownPerServing;
      if (addPrice && shown) addPrice.textContent = shown;
      if (stickyPrice && shown) stickyPrice.textContent = shown;
      updateButtonLabels(subscriptionSelected, input, available);
      setPurchaseMode(subscriptionSelected ? 'subscription' : 'once');
      if (shouldTrack) {
        const selectionPayload = {
          ...productData(),
          supply_size: Number(input.dataset.packSize || 0) || null,
          purchase_type: subscriptionSelected ? 'subscription' : 'one_time'
        };
        track('supply_selected', selectionPayload);
        track(subscriptionSelected ? 'subscription_selected' : 'one_time_selected', {
          ...selectionPayload,
          selling_plan_id: subscriptionSelected ? input.dataset.planId : null,
          selling_plan_name: subscriptionSelected ? input.dataset.planName : null
        });
      }
    };
    form?.querySelectorAll('[data-kc-variant]').forEach(input => input.addEventListener('change', () => updateVariant(input, true)));
    form?.querySelectorAll('[data-kc-purchase]').forEach(input => input.addEventListener('change', () => {
      const chosenVariant = form.querySelector('[data-kc-variant]:checked');
      const subscribed = input.value === 'subscription';
      sellingPlan.value = subscribed ? (chosenVariant?.dataset.planId || product.dataset.planId || '') : '';
      sellingPlan.disabled = !subscribed;
      const shown = subscribed
        ? (chosenVariant?.dataset.planPrice || product.dataset.planPrice)
        : (chosenVariant?.dataset.priceFormatted || oncePrice?.textContent || price?.textContent);
      if (addPrice && shown) addPrice.textContent = shown;
      if (stickyPrice && shown) stickyPrice.textContent = shown;
      if (price && shown) price.textContent = shown;
      if (sachetPlan && planPrice && shown) planPrice.textContent = shown;
      const shownPerServing = subscribed
        ? (chosenVariant?.dataset.planPerServing || product.dataset.planPerServing)
        : (chosenVariant?.dataset.perServing || (onceServing?.textContent ? `${onceServing.textContent}${T.perServing}` : ''));
      if (perServing && shownPerServing) perServing.textContent = shownPerServing;
      updateButtonLabels(subscribed, chosenVariant, canPurchase(chosenVariant));
      renderSachetMode(chosenVariant);
      track(subscribed ? 'subscription_selected' : 'one_time_selected', {
        ...productData(),
        supply_size: Number(chosenVariant?.dataset.packSize || 0) || null,
        selling_plan_id: subscribed ? sellingPlan.value : null,
        selling_plan_name: subscribed ? (chosenVariant?.dataset.planName || product.dataset.planName) : null
      });
    }));
    quietOnce?.addEventListener('click', () => setPurchaseMode(selectedPurchase() === 'subscription' ? 'once' : 'subscription', true));
    updateVariant(form?.querySelector('[data-kc-variant]:checked'));
    form?.addEventListener('submit', () => {
      const chosenVariant = form.querySelector('[data-kc-variant]:checked');
      track('add_to_bag', {
        ...productData(),
        supply_size: Number(chosenVariant?.dataset.packSize || 0) || null,
        selling_plan_id: sellingPlan.disabled ? null : sellingPlan.value,
        purchase_type: sellingPlan.disabled ? 'one_time' : 'subscription'
      });
    });
    stickyAdd?.addEventListener('click', () => form?.requestSubmit());

    const sticky = product.querySelector('[data-kc-sticky]');
    if (sticky && add) {
      new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(add);
    }
  }

  const collection = document.querySelector('.kc-collection');
  if (collection) {
    track('collection_viewed', { product_count: collection.querySelectorAll('[data-kc-product-card]').length });
    collection.querySelectorAll('[data-kc-product-card]').forEach(card => card.addEventListener('click', () => {
      track('product_card_selected', {
        product_id: card.dataset.productId,
        product_handle: card.dataset.productHandle,
        product_title: card.dataset.productTitle
      });
    }));
  }

  const cart = document.querySelector('.kc-cart');
  const cartItems = cart ? [...cart.querySelectorAll('[data-kc-cart-item]')].map(item => ({
    product_id: item.dataset.productId,
    product_handle: item.dataset.productHandle,
    product_title: item.dataset.productTitle,
    variant_id: item.dataset.variantId,
    supply_size: Number(item.dataset.supplySize || 0) || null,
    purchase_type: item.dataset.purchaseType,
    quantity: Number(item.dataset.quantity || 0),
    line_price: Number(item.dataset.linePrice || 0) / 100
  })) : [];
  if (cart) track('cart_viewed', {
    item_count: Number(cart.querySelector('.kc-cart__hero > span')?.textContent.match(/\d+/)?.[0] || 0),
    items: cartItems
  });

  document.querySelectorAll('[data-kc-checkout]').forEach(button => button.addEventListener('click', () => {
    track('checkout_started', {
      cart_total: Number(button.dataset.cartTotal || 0) / 100,
      currency: button.dataset.currency || 'CAD',
      items: cartItems
    });
  }));
})();
